import React from "react";
import { Image, Text, View } from "react-native";
import { AppImages } from "../utility/AppImages";
import { AppColors } from "../utility/AppColors";
import { AppFontStyle } from "../styles/AppFontStyle";
import { useTooltips } from "../context/WalkthroughContext";
import SidebarTopWalkthrough from "../Components/walk-through-common-components/homeScreenTooltips/SidebarTopWalkthrough";

const CustomHomeFooterDrawer = ({ toggleMoreModal, focused }) => {
  const { homeWalkThroughVisible } = useTooltips();
  const iconColor = focused ? AppColors.buttonRed_DC2626 : "#FFFFFF";
  const textColor = focused ? AppColors.buttonRed_DC2626 : "#FFFFFF";

  return homeWalkThroughVisible ? (
    <SidebarTopWalkthrough
      toggleMoreModal={toggleMoreModal}
      content={
        <View
          style={{
            paddingVertical: 5,
            gap: 5,
            alignItems: "center",
          }}
        >
          <Image
            source={AppImages.icHome}
            style={{
              width: 28,
              height: 28,
              resizeMode: "contain",
              tintColor: iconColor,
            }}
          />
          <Text style={[AppFontStyle.BOLD_ANYBODY_12, { color: textColor }]}>Home</Text>
        </View>
      }
    />
  ) : (
    <View
      style={{
        padding: 10,
        gap: 5,
        alignItems: "center",
      }}
    >
      <Image
        source={AppImages.icHome}
        style={{
          width: 28,
          height: 28,
          resizeMode: "contain",
          tintColor: iconColor,
        }}
      />
      <Text style={[AppFontStyle.BOLD_ANYBODY_12, { color: textColor }]}>Home</Text>
    </View>
  );
};

export default CustomHomeFooterDrawer;
